import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  margin-bottom: 0px;
`

export default {
  Container
}
